import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useCustomer } from 'lib/core/hooks'
import { useStoreView } from 'hooks/useStoreView'
import { Wrapper } from './components/Styled'
import { useComparisonContext } from 'lib/modules/catalog'

export const AccountLinks = () => {
  const history = useHistory()
  const { isLoggedIn, customer, logout } = useCustomer()
  const { isLivBrite } = useStoreView()
  const { getProductsToCompare } = useComparisonContext()
  const [compareProducts, setCompareProducts] = useState<string[]>(getProductsToCompare())
  const productsQty = compareProducts?.filter((product: string) => product !== '')?.length ?? 0

  useEffect(() => history.listen(() => {
    if (history.location.pathname === '/product-comparison') {
      const productsToCompare = getProductsToCompare()
      setCompareProducts(productsToCompare)
    }
  }), [history, getProductsToCompare])

  // @ts-expect-error // eslint-disable-next-line
  const isEmployee = customer?.customerType === 1
  return (
    <Wrapper
      isLivBrite={isLivBrite}
    >
      <ul>
        {productsQty > 0 && (
          <li>
            <Link to='/product-comparison'>
              Compare Products
              <span>({`${productsQty} items`})</span>
            </Link>
          </li>
        )}
        {isLoggedIn ? (
          <>
            {!isEmployee && (
              <li>
                <Link to='/customer/account/dashboard'>
                  My Account
                </Link>
              </li>
            )}
            {isLivBrite && isEmployee && (
              <li>
                <Link to='/customer/account/community'>
                  Community Dashboard
                </Link>
              </li>
            )}
            <li>
              <span onClick={() => logout()}>
                Log Out
              </span>
            </li>
          </>
        ) : (
          <>
            <li>
              <Link to='/customer/account/login'>
                Sign In
              </Link>
            </li>
            <li>
              <Link to='/customer/account/create'>
                <strong>Create Account</strong>
              </Link>
            </li>
          </>
        )}
      </ul>
    </Wrapper>
  )
}
